import { render, staticRenderFns } from "./NewEvent.vue?vue&type=template&id=dd533dee&scoped=true&"
import script from "./NewEvent.vue?vue&type=script&lang=js&"
export * from "./NewEvent.vue?vue&type=script&lang=js&"
import style0 from "./NewEvent.vue?vue&type=style&index=0&id=dd533dee&lang=sass&scoped=true&"
import style1 from "./NewEvent.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd533dee",
  null
  
)

export default component.exports